import { useEffect, useState } from "react";
import { useFormik } from "formik";
import Select from "react-select";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import CodeEditor from "../../Components/CodeEditor";
import { SwitchToggle } from "../../Components/TableHelper";
import { Plus, X } from "lucide-react";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInterceptor";
import { useLocation, useNavigate } from "react-router-dom";
import { customStyles } from "../../utils/constant";
import SingleImageUploader from "../../Components/SingleImageUploader";
import Breadcrumb from "../../Components/Breadcrumb";

const rowTypeOptions = [
  { value: "FullEditor", label: "Full Editor" },
  { value: "TwoColumn", label: "Two Column" },
];
const contentTypeOptions = [
  { value: "Editor", label: "Editor" },
  { value: "Image", label: "Image" },
  { value: "Iframe", label: "Iframe" },
];
const AddCms = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const [loading] = useState(false);
  const [rowModalOpen, setRowModalOpen] = useState(false);
  const [selectedRowType, setSelectedRowType] = useState(null);
  const editData = location.state;
  const editingId = editData?._id;
  const initialValues = {
    title: editData?.title || editData?.cmsId?.title || "",
    isActive: editData?.isActive ?? true,
    rows: editData?.rows || editData?.cmsId?.rows || [],
  };

  useEffect(() => {
    if (editData?.cmsId?.type) {
      setFieldValue("type", editData.cmsId.type);
    }
  }, [editData]);

  const { values, setFieldValue, handleChange, handleSubmit } = useFormik({
    initialValues,

    onSubmit: async (vals) => {
      const editId = editData?.cmsId ? editData?.cmsId?._id : editData?._id
      try {
        const reponse = editData?._id
          ? await axiosInstance.put(`cms/updatecms/${editId}`, vals)
          : await axiosInstance.post("cms/createcms", vals);
        toast.success(reponse.data.message);
        navigator(-1);
      } catch (err) {
        toast.error(err.response.data.message);
      }
    },
  });

  const handleOpenAddRow = () => {
    setSelectedRowType(null);
    setRowModalOpen(true);
  };

  const handleSaveRow = () => {
    if (!selectedRowType) return;

    const newRow = {
      rowType: selectedRowType.value,
      fullContentValue: "",
      leftContentType: "",
      leftContentValue: "",
      rightContentType: "",
      rightContentValue: "",
      fullContentimage: "",
      isActive: true,
      sortOrder: values.rows.length + 1,
    };

    setFieldValue("rows", [...values.rows, newRow]);
    setRowModalOpen(false);
  };

  const handleRemoveRow = (index) => {
    const updated = values.rows.filter((_, i) => i !== index);
    setFieldValue("rows", updated);
  };

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "CMS", path: "/cms" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3 className="custom-page-title">
          {editingId ? "Update" : "Add"} CMS
        </h3>

        <Breadcrumb items={breadcrumbdata} />
      </div>

      <div className="col-md-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row px-3">
                <div className="col-sm-12 mb-3">
                  <label className="form-label fw-semibold">CMS Name</label>
                  <input
                    type="text"
                    name="title"
                    className="form-control"
                    placeholder="Enter a name"
                    value={values.title}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-sm-12 mb-3 d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">Rows:</h5>

                  <Button size="xs" color="primary" onClick={handleOpenAddRow}>
                    <Plus size={14} className="me-1" />
                    Add Row
                  </Button>
                </div>

                {values.rows.map((row, index) => (
                  <div className="col-sm-12 mb-4 p-3 border-top " key={index}>
                    <div className="d-flex justify-content-between mb-2">
                      <h5>
                        Row {index + 1} ({row.rowType})
                      </h5>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleRemoveRow(index)}
                      >
                        <X size={18} /> Remove
                      </Button>
                    </div>

                    {row.rowType === "FullEditor" && (
                      <div className="row align-items-start">
                        <div className="col-sm-6">
                          <label className="form-label fw-semibold d-block">
                            Row Active
                          </label>
                          <SwitchToggle
                            checked={row.isActive}
                            hideLabel={true}
                            onChange={(val) =>
                              setFieldValue(`rows[${index}].isActive`, val)
                            }
                          />
                        </div>
                        <div className="col-sm-6 mb-3">
                          <label className="form-label fw-semibold">
                            Sort Order
                          </label>
                          <input
                            type="number"
                            className={`border border-dark form-control form-control-sm `}
                            value={row.sortOrder}
                            onChange={(e) =>
                              setFieldValue(
                                `rows[${index}].sortOrder`,
                                e.target.value,
                              )
                            }
                          />
                        </div>

                        <div className="col-sm-12 mb-3">
                          <label className="form-label fw-semibold">
                            Content
                          </label>
                          <CodeEditor
                            value={row.fullContentValue}
                            onChange={(val) =>
                              setFieldValue(
                                `rows[${index}].fullContentValue`,
                                val,
                              )
                            }
                          />
                        </div>
                      </div>
                    )}

                    {row.rowType === "TwoColumn" && (
                      <>
                        <div className="row">
                          <div className="col-sm-1">
                            <label className="form-label fw-semibold d-block">
                              Row Active
                            </label>
                            <SwitchToggle
                              checked={row.isActive}
                              hideLabel={true}
                              onChange={(val) =>
                                setFieldValue(`rows[${index}].isActive`, val)
                              }
                            />
                          </div>
                          <div className="col-sm-1 mb-3">
                            <label className="form-label fw-semibold">
                              Sort Order
                            </label>
                            <input
                              type="number"
                              className="form-control form-control-sm"
                              value={row.sortOrder}
                              onChange={(e) =>
                                setFieldValue(
                                  `rows[${index}].sortOrder`,
                                  e.target.value,
                                )
                              }
                            />
                          </div>

                          <div className="col-sm-5">
                            <label className="form-label fw-semibold">
                              Left Type
                            </label>
                            <Select
                              styles={customStyles}
                              options={contentTypeOptions}
                              value={
                                contentTypeOptions.find(
                                  (o) => o.value === row.leftContentType,
                                ) || null
                              }
                              onChange={(opt) =>
                                setFieldValue(
                                  `rows[${index}].leftContentType`,
                                  opt?.value || "",
                                )
                              }
                            />
                          </div>

                          <div className="col-sm-5">
                            <label className="form-label fw-semibold">
                              Right Type
                            </label>
                            <Select
                              styles={customStyles}
                              options={contentTypeOptions}
                              value={
                                contentTypeOptions.find(
                                  (o) => o.value === row.rightContentType,
                                ) || null
                              }
                              onChange={(opt) =>
                                setFieldValue(
                                  `rows[${index}].rightContentType`,
                                  opt?.value || "",
                                )
                              }
                            />
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-sm-6">
                            {row.leftContentType === "Editor" && (
                              <CodeEditor
                                value={row.leftContentValue}
                                onChange={(val) =>
                                  setFieldValue(
                                    `rows[${index}].leftContentValue`,
                                    val,
                                  )
                                }
                              />
                            )}

                            {row.leftContentType === "Image" && (
                              <SingleImageUploader
                                label="Left Image"
                                value={row.leftContentValue}
                                onChange={(path) =>
                                  setFieldValue(
                                    `rows[${index}].leftContentValue`,
                                    path,
                                  )
                                }
                              />
                            )}

                            {row.leftContentType === "Iframe" && (
                              <input
                                type="text"
                                className="form-control mt-2"
                                placeholder="Iframe URL"
                                value={row.leftContentValue}
                                onChange={(e) =>
                                  setFieldValue(
                                    `rows[${index}].leftContentValue`,
                                    e.target.value,
                                  )
                                }
                              />
                            )}
                          </div>

                          <div className="col-sm-6">
                            {row.rightContentType === "Editor" && (
                              <CodeEditor
                                value={row.rightContentValue}
                                onChange={(val) =>
                                  setFieldValue(
                                    `rows[${index}].rightContentValue`,
                                    val,
                                  )
                                }
                              />
                            )}

                            {row.rightContentType === "Image" && (
                              <SingleImageUploader
                                label="Right Image"
                                value={row.rightContentValue}
                                onChange={(path) =>
                                  setFieldValue(
                                    `rows[${index}].rightContentValue`,
                                    path,
                                  )
                                }
                              />
                            )}

                            {row.rightContentType === "Iframe" && (
                              <input
                                type="text"
                                className="form-control mt-2"
                                placeholder="Iframe URL"
                                value={row.rightContentValue}
                                onChange={(e) =>
                                  setFieldValue(
                                    `rows[${index}].rightContentValue`,
                                    e.target.value,
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>

              <div className="text-center mt-4">
                <Button
                  type="submit"
                  color="primary"
                  disabled={loading || !values.title.trim()}
                >
                  {loading ? (
                    <span className="d-inline-flex align-items-center gap-2">
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Processing...
                    </span>
                  ) : (
                    "Save"
                  )}
                </Button>


                <Button
                  color="danger"
                  className="mx-2"
                  onClick={() => navigator(-1)}
                >
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Modal
        isOpen={rowModalOpen}
        toggle={() => setRowModalOpen(false)}
        top
        className="white-modal"
      >
        <ModalHeader toggle={() => setRowModalOpen(false)}>
          Row Type
        </ModalHeader>
        <ModalBody>
          <label className="form-label fw-semibold">Select Row Type</label>
          <Select
            styles={customStyles}
            options={rowTypeOptions}
            value={selectedRowType}
            onChange={setSelectedRowType}
            placeholder="Choose row type"
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setRowModalOpen(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleSaveRow}
            disabled={!selectedRowType}
          >
            Save Row
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AddCms;
